interface Props {
  play: boolean;
  onClick: () => void;
}
const SvgPlayPause: React.FC<Props> = ({ play, onClick }) => {
  return play ? (
    <svg
      onClick={onClick}
      style={{ cursor: "pointer" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="6" className="fill-primary" />
      <g clipPath="url(#clip0_18545_102796)">
        <path
          d="M10.5312 15.9199H8.84375C8.37793 15.9199 8 15.542 8 15.0762V8.88867C8 8.42285 8.37793 8.04492 8.84375 8.04492H10.5312C10.9971 8.04492 11.375 8.42285 11.375 8.88867V15.0762C11.375 15.542 10.9971 15.9199 10.5312 15.9199ZM15.875 15.0762V8.88867C15.875 8.42285 15.4971 8.04492 15.0312 8.04492H13.3438C12.8779 8.04492 12.5 8.42285 12.5 8.88867V15.0762C12.5 15.542 12.8779 15.9199 13.3438 15.9199H15.0312C15.4971 15.9199 15.875 15.542 15.875 15.0762Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_18545_102796">
          <rect
            width="7.875"
            height="9"
            fill="white"
            transform="translate(8 7.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      style={{ cursor: "pointer" }}
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="6" className="fill-primary" />
      <path
        d="M8.84912 7.0282C8.27605 7.05088 7.75 7.51842 7.75 8.14832V15.8524C7.75 16.6923 8.68569 17.2433 9.42041 16.8363L16.3726 12.9843C17.1284 12.5654 17.1284 11.4353 16.3726 11.0165L9.42041 7.16443C9.23673 7.06267 9.04014 7.02065 8.84912 7.0282Z"
        fill="white"
      />
    </svg>
  );
};

export default SvgPlayPause;
